module.exports = __webpack_public_path__ + "static/img/btn_terrain.6a17c00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn_terrain.png
// module id = 6qd9
// module chunks = 3